import React, {
  useMemo,
} from 'react'

import PropTypes from 'prop-types'

import UserTagsContext from './UserTagsContext'

import useUserTagsQuery from './hooks/useUserTagsQuery'


export default function UserTagsProvider({ children }) {
  const {
    isLoading,
    refetch,
    userTags,
  } = useUserTagsQuery()

  const value = useMemo(() => ({
    isLoading,
    refetch,
    userTags,
  }), [isLoading, refetch, userTags])

  return (
    <UserTagsContext.Provider
      value={ value }
    >
      { children }
    </UserTagsContext.Provider>
  )
}

UserTagsProvider.propTypes = {
  children: PropTypes.node,
}
